module.exports = __webpack_public_path__ + "static/media/LookBook.78f5226e.jpg";